export default "__VITE_ASSET__CPztAYIr__"